import { ToggleButtonProps as MuiToggleButtonProps } from '@mui/material/ToggleButton/ToggleButton';
import { OverridableStringUnion } from '@mui/types';
import { forwardRef } from 'react';
import MuiToggleButton, { ToggleButtonPropsColorOverrides } from '@mui/material/ToggleButton';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

declare module '@mui/material/ToggleButton' {
  interface ToggleButtonPropsColorOverrides {
    default: true;
    internal: true;
  }
}

export interface ToggleButtonProps extends MuiToggleButtonProps {
  /**
   * Variant with predefined checkbox icon (it automatically adds some styling).
   */
  withCheckbox?: boolean;
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error' | 'internal',
    ToggleButtonPropsColorOverrides
  >;
}

const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>((props, ref) => {
  const { children, selected, withCheckbox, color, ...other } = props;

  return (
    <MuiToggleButton ref={ref} selected={selected} color={color} {...other}>
      {withCheckbox &&
        (selected ? (
          <CheckBoxIcon sx={{ marginRight: '6px' }} />
        ) : (
          <CheckBoxOutlineBlankIcon sx={{ marginRight: '6px' }} />
        ))}
      {children}
    </MuiToggleButton>
  );
});

ToggleButton.displayName = 'ToggleButton';

export default ToggleButton;
